export const RENEWAL_TERM_OPTIONS = [
  { label: '1 month', value: 1 },
  { label: '6 months', value: 6 },
  { label: '1 year', value: 12 },
  { label: 'Other', value: 0 }
] as const
